import http from '../http'
import {
  APPLICANT_EDIT_URL,
  APPLICANT_LIST_URL,
  APPLICANT_CREATE_URL,
  APPLICANT_STATISTIC_URL,
  APPLICANT_STATUS_URL,
  STATUS_LIST,
  ECONOMY_LIST
} from '../../services/endpoints'

export function getApplicantList(data) {
  return http.request({
    url: APPLICANT_LIST_URL,
    method: 'post',
    data: data
  })
}
export function getApplicant(id) {
  return http.request({
      url:APPLICANT_EDIT_URL(id),
      method:'get'
  })
}
export function generatePdfDecision(id) {

  getApplicant(id).then(response => {
    window.applicant = response.data
  })

  return http.request({
    url:APPLICANT_EDIT_URL(id)+'/generate-decision',
    responseType: 'blob',
    method:'post'
  }).then((response) => {
    let blob = new Blob([response], {type: 'application/pdf'});
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download',`${window.applicant.first_name}${window.applicant.last_name}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  })
}


export function updateApplicant(id, postData) {
  return http.request({
    url:APPLICANT_EDIT_URL(id),
    method:'put',
    data:postData
  })
}
export function createApplicant(postData) {
  return http.request({
    url: APPLICANT_CREATE_URL,
    method:'post',
    data:postData
  })
}
export function changeApplicantStatus(id, postData) {
  return http.request({
    url:APPLICANT_STATUS_URL(id),
    method:'post',
    data:postData
  })
}
export function deleteApplicant(id) {
  return http.request({
    url:APPLICANT_EDIT_URL(id),
    method:'delete'
  })
}
export function statisticApplicant(data) {
  return http.request({
    url:APPLICANT_STATISTIC_URL,
    method:'get',
    params:data
  })
}
export function groupApplicantExport(data,filetype) {
  return http.request({
    url:`api/applicant/group-export?${filetype}`,
    method: 'post',
    responseType: 'blob',
    data: data
  }).then((response) => {
 
    let blob = new Blob([response], {type: 'application/'+filetype});

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    if(data.data.length === 1) {
      link.setAttribute('download', `${data.data[0].first_name}${data.data[0].last_name}.${filetype}`);
    }else{
      link.setAttribute('download', `export.${filetype}`);
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  })
}
export function getStatusList() {
  return http.request({
    url:STATUS_LIST,
    method:'get',
  })
}
